import React, { useEffect, useRef } from "react";
import {
    useTable,
    useGlobalFilter,
    useFilters,
    usePagination,
    useSortBy,
} from "react-table";
import "./ReactTable.css";

const OrderTable = ({ columns, data, getFilterValue,onDataUpdate }) => {

    const tableInstance = useTable(
        {
            columns,
            data,
            //  filters:[...JSON.parse(localStorage.getItem('filterValues'))],
            sortTypes: {
                alphanumeric: (row1, row2, columnName) => {
                    let rowOneColumn = row1.values[columnName];
                    let rowTwoColumn = row2.values[columnName];
                    // Handle empty or undefined values
                    if (rowOneColumn == null) {
                        rowOneColumn = "";
                    }
                    if (rowTwoColumn == null) {
                        rowTwoColumn = "";
                    }

                    const column = columns.find((col) => col.accessor === columnName);
                    let num1, num2, date1, date2;

                    if (
                        column?.fieldType === "commaSeparator" &&
                        (rowOneColumn?.includes(",") || rowTwoColumn?.includes(","))
                    ) {
                        num1 = parseInt(rowOneColumn.replace(/,/g, ""), 10);
                        num2 = parseInt(rowTwoColumn.replace(/,/g, ""), 10);
                    } else if (column?.fieldType === "Date") {
                        // Parse the values as dates
                        date1 = new Date(rowOneColumn);
                        date2 = new Date(rowTwoColumn);
                        if (!isNaN(date1.getTime()) && !isNaN(date2.getTime())) {
                            // Compare dates
                            return date1 > date2 ? 1 : date1 < date2 ? -1 : 0;
                        } else {
                            // If one or both are invalid, push invalid dates to the bottom
                            return isNaN(date1.getTime()) ? 1 : -1;
                        }
                    }
                    else {
                        // Attempt to parse values as floats
                        num1 = parseFloat(rowOneColumn);
                        num2 = parseFloat(rowTwoColumn);
                    }

                    // Check if both values are numeric
                    const isNumericColumn = !isNaN(num1) && !isNaN(num2);

                    if (isNumericColumn) {
                        // Perform numeric comparison
                        return num1 > num2 ? 1 : num1 < num2 ? -1 : 0;
                    } else if (Number.isInteger(rowOneColumn) || Number.isInteger(rowTwoColumn)) {
                        return num1 > num2 ? 1 : num1 < num2 ? -1 : 0;
                    }
                    else {
                        // Perform alphanumeric comparison
                        if (rowOneColumn) {

                            return rowOneColumn?.toLowerCase() > rowTwoColumn?.toLowerCase()
                                ? 1
                                : -1;
                        } else {
                            return -1
                        }

                    }
                },
            },
            initialState: { pageIndex: 0 },
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        state,
        page,
        gotoPage,
        pageCount,
        pageOptions,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        setFilter,
        state: { filters },
        rows
    } = tableInstance;

const prevDataRef = useRef([]);

 useEffect(() => {
  const currentData = rows.map(row => row.original);
  const currentString = JSON.stringify(currentData);
  if (prevDataRef.current !== currentString && onDataUpdate) {
    onDataUpdate(currentData);
    prevDataRef.current = currentString;
  }
}, [rows, onDataUpdate]);

    useEffect(() => {
        if (localStorage.getItem('filterValues') && data?.length>0) {
            const filteredValues = JSON.parse(localStorage.getItem('filterValues'));
            if(filteredValues && filteredValues.length > 0){
                filteredValues.forEach(x => {
                    setFilter(x.id, x.value)
                });
            }
        }
    
    }, [localStorage.getItem('filterValues'),data])


    const getTableFilterValue = (columnId) => {
        const filter = filters.find((filter) => filter.id === columnId);
        return filter ? filter.value : "";
    };

    
    useEffect(() => {
        const OrderNumber = filters.find((filter) => filter.id === "OrderNumber")?.value || "";
        const ClientName = filters.find((filter) => filter.id === "ClientName")?.value || "";
        const OrderSource = filters.find((filter) => filter.id === "OrderSource")?.value || "";
        const Woocommerce = filters.find((filter) => filter.id === "Woocommerce")?.value || "";
        const OrderStatus = filters.find((filter) => filter.id === "OrderStatus")?.value || "";
        const CreatedDateString = filters.find((filter) => filter.id === "CreatedDateString")?.value || "";
        const GrandTotalStr = filters.find((filter) => filter.id === "GrandTotalStr")?.value || "";
       
        getFilterValue( [
            {
                id: "ClientName",
                value: ClientName
            },
            {
                id: "OrderSource",
                value: OrderSource
            }, {
                id: "Woocommerce",
                value: Woocommerce
            }, {
                id: "OrderStatus",
                value: OrderStatus
            }, {
                id: "CreatedDateString",
                value: CreatedDateString
            },
            {
                id: "GrandTotalStr",
                value: GrandTotalStr
            }, {
                id: "OrderNumber",
                value: OrderNumber
            }
        ])

    }, [filters]);


    const { pageIndex } = state;

    return (
        <>
            <div className="table-responsive">
                {/* <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} /> */}
                <table {...getTableProps()} className="table display">
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => {
                                    const filterValue = getTableFilterValue(column.id);
                                    return <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                        <span className="ml-1">
                                            {column.render("Header")}
                                            {column.isSorted ? (
                                                column.isSortedDesc ? (
                                                    <i className="fa fa-arrow-down" />
                                                ) : (
                                                    <i className="fa fa-arrow-up" />
                                                )
                                            ) : (
                                                ""
                                            )}
                                        </span>
                                        {/* {column.canFilter ? column.render("Filter") : null} */}
                                        {column.canFilter && (
                                            <div>
                                                <input
                                                    className="form-control input-search"
                                                    value={filterValue}
                                                    onChange={(e) => column.setFilter(e.target.value)}
                                                />
                                            </div>
                                        )}
                                    </th>
                                })}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()} className="">
                        {(page &&
                            page.length > 0 &&
                            page.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (
                                                <td
                                                    style={{ textAlign: cell?.column?.justify }}
                                                    {...cell.getCellProps()}
                                                >
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })) || (
                                <tr>
                                    <td
                                        colSpan={columns && columns.length}
                                        className="norecordfound"
                                    >
                                        <span>No Records Found</span>
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
                <div className="d-flex justify-content-between">
                    <span>
                        Page{" "}
                        <strong>
                            {pageIndex + 1} of {pageOptions.length}
                        </strong>
                    </span>
                    <span className="table-index">
                        Go to page :
                        <input
                            type="number"
                            className="ml-2"
                            defaultValue={pageIndex + 1}
                            onChange={(e) => {
                                const pageNumber = e.target.value
                                    ? Number(e.target.value) - 1
                                    : 0;
                                gotoPage(pageNumber);
                            }}
                        />
                    </span>
                </div>
                <div className="text-center">
                    <div className="filter-pagination mt-3">
                        <button
                            className="previous-button"
                            onClick={() => gotoPage(0)}
                            disabled={!canPreviousPage}
                        >
                            {"<<"}
                        </button>
                        <button
                            className="previous-button"
                            onClick={() => previousPage()}
                            disabled={!canPreviousPage}
                        >
                            Previous
                        </button>
                        <button
                            className="next-button"
                            onClick={() => nextPage()}
                            disabled={!canNextPage}
                        >
                            Next
                        </button>
                        <button
                            className="next-button"
                            onClick={() => gotoPage(pageCount - 1)}
                            disabled={!canNextPage}
                        >
                            {">>"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OrderTable;
